<div class="tab-pane" role="tabpanel" id="caract_anteproyecto">
    <fieldset id="agregar_caract_anteproyecto" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Caracteristica del proyecto</strong></h3>
                        <hr>
                        <div class="form-horizontal">
                            <div class="form-group" align="left" >
                                <label for="anteproy_aprob" class="col-md-4">Cuenta con modificaci&oacute;n de proyecto aprobada</label>
                                <div class="col-md-6 inline">
                                    <mat-radio-group formControlName="mod_aprob" (change)="add_cuenta_con_mod()">
                                        <mat-radio-button style="padding-right: 20px" name="anteproy_aprob" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="anteproy_aprob" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="form-group" align="left" >
                                <div class="col-md-2">
                                    <label for="numero" style="padding-bottom: 20px; padding-top: 15px;">Res. N°</label>
                                </div>
                                <div class="col-md-3" >
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Numero" id="numero" name="numero" formControlName="numero" (change)="add_cuenta_con_mod()" [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="form.controls?.numero.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" for="fecha" style="padding-bottom: 20px; padding-top: 15px;">Fecha</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="dateinput" style="width: 145px;">
                                        <input matInput [matDatepicker]="dp4" [max]="maxDate" formControlName="fecha" disabled (dateInput)="add_cuenta_con_mod($event, 'input')" (dateChange)="add_cuenta_con_mod($event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                        <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>